
import { Link } from "react-router-dom";
import Logo from "../../../../assets/images/Logo.svg";

export default function DrawerHeader() {
  return (
    <div className="flex justify-center items-center pb-4 w-full">
      <Link to={"/"}>
        <img src={Logo} alt="Logo" className={"w-[136px] h-[32px]"} />
      </Link>
    </div>
  );
}
